<script>
import { menuLinks } from '@/constants';
import ErrorAccessDenied from '@/components/ErrorAccessDenied';

export default {
  beforeCreate () {
    const { user } = this.$store.state.auth;
    const firstMatch = menuLinks
      .find(link => user.permissions.includes(link.permission));

    if (firstMatch) {
      this.$router.replace(firstMatch.to);
    }
  },
  render () {
    return (
      <ErrorAccessDenied />
    );
  },
};
</script>
